import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ChipsModule } from 'primeng/chips';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { KeyFilterModule } from 'primeng/keyfilter';
import { InputTextModule } from 'primeng/inputtext';
import { TableModule } from 'primeng/table';
import { DatePipe } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NotificationsService } from './core/services/notifications/notifications.service';
import { LoaderService } from './shared/components/loader/loader.service';
import { ConfirmationService } from 'primeng/api';
import { RequestInterceptor } from './core/auth/request.interceptor';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    ChipsModule,
    ReactiveFormsModule,
    FormsModule,
    BrowserAnimationsModule 
  ],
  providers: [DatePipe, {
    provide: HTTP_INTERCEPTORS,
    useClass: RequestInterceptor,
    multi: true
  }, NotificationsService, LoaderService, ConfirmationService],
  bootstrap: [AppComponent]
})
export class AppModule { }
